import { createReducer, on } from '@ngrx/store';

import { DetailedUser } from '../users.common';
import { BackAuthUserSelectedReset, BackAuthUserSelectedSet } from './users-global.actions';

export const BackAuthUsersGlobalFeatureKey = 'global';
export interface IBackUsersGlobalState
{
    selected: DetailedUser;
}
export const BackUsersGlobalInitialState: IBackUsersGlobalState =
{
    selected: null

};
export const BackAuthUsersGlobalReducer = createReducer(
    BackUsersGlobalInitialState,
    on(
        BackAuthUserSelectedSet,
        (state: IBackUsersGlobalState, { user }: { user: DetailedUser }) =>
            ({
                ...state,
                selected: user
            })
    ),
    on(
        BackAuthUserSelectedReset,
        (state: IBackUsersGlobalState) =>
            ({
                ...state,
                selected: null
            })
    )
);
